import React from 'react';
import { Modal } from 'antd';

const ImportResultModal = ({ open, onClose, result }) => {
  if (!result) return null;

  const { imported = 0, errors = 0, details = [] } = result;

  const downloadErrorsCsv = () => {
    if (!details || details.length === 0) return;

    const rows = [
      ['Ligne', 'Produit', 'Erreur']
    ];
    details.forEach((d) => {
      if (d.error) {
        rows.push([
          (d.index ?? '') + 2, // +2: 1 pour header, 1 pour index 0-based
          d.product || '',
          d.error || ''
        ]);
      }
    });

    const csv = rows.map(r => r.map(cell => {
      const value = String(cell ?? '').replace(/"/g, '""');
      return `"${value}"`;
    }).join(',')).join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `erreurs-import-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Modal
      title="Résultat de l'import"
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText="Fermer"
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <div style={{ display: 'flex', gap: 16, marginBottom: 12 }}>
        <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: 12, flex: 1 }}>
          <div style={{ color: '#389e0d', fontWeight: 600 }}>Importés</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{imported}</div>
        </div>
        <div style={{ background: '#fff1f0', border: '1px solid #ffa39e', borderRadius: 8, padding: 12, flex: 1 }}>
          <div style={{ color: '#cf1322', fontWeight: 600 }}>Erreurs</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{errors}</div>
        </div>
      </div>

      {errors > 0 && (
        <>
          <button
            onClick={downloadErrorsCsv}
            style={{
              background: '#1677ff',
              color: '#fff',
              border: 0,
              borderRadius: 6,
              padding: '8px 12px',
              cursor: 'pointer',
              marginBottom: 12
            }}
          >
            Télécharger le CSV des erreurs
          </button>
          <div style={{ maxHeight: 220, overflow: 'auto', borderTop: '1px solid #f0f0f0', paddingTop: 8 }}>
            {details.filter(d => d.error).slice(0, 50).map((d, idx) => (
              <div key={idx} style={{ fontSize: 13, marginBottom: 6 }}>
                <strong>Ligne {(d.index ?? '') + 2}</strong> — {d.product || 'Inconnu'}
                <div style={{ color: '#cf1322' }}>{d.error}</div>
              </div>
            ))}
            {details.filter(d => d.error).length > 50 && (
              <div style={{ color: '#8c8c8c', fontSize: 12 }}>
                ... {details.filter(d => d.error).length - 50} erreurs supplémentaires (voir CSV)
              </div>
            )}
          </div>
        </>
      )}
    </Modal>
  );
};

export default ImportResultModal;


